"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMessageType = void 0;
var EMessageType;
(function (EMessageType) {
    EMessageType["TEXT"] = "TEXT";
    EMessageType["IMAGE"] = "IMAGE";
    EMessageType["AUDIO"] = "AUDIO";
    EMessageType["VIDEO"] = "VIDEO";
    EMessageType["FILE"] = "FILE";
})(EMessageType || (exports.EMessageType = EMessageType = {}));
